import { render, staticRenderFns } from "./cadre-footer.component.vue?vue&type=template&id=35fce6c1&scoped=true&"
import script from "./cadre-footer.component.ts?vue&type=script&lang=ts&"
export * from "./cadre-footer.component.ts?vue&type=script&lang=ts&"
import style0 from "./cadre-footer.component.scss?vue&type=style&index=0&id=35fce6c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fce6c1",
  null
  
)

export default component.exports